export const blockIconsCommunicationPermPhoneMsgNew = (
	<span className='material-symbols-outlined'>perm_phone_msg</span>
);
